import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5013/api/v1';

function authHeaders() {
  const token = localStorage.getItem('knkt_crm_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const contactsApi = {
  getAll: (params = {}) =>
    axios.get(`${BASE}/contacts`, { params, headers: authHeaders() }).then(r => r.data),

  getStats: () =>
    axios.get(`${BASE}/contacts/stats`, { headers: authHeaders() }).then(r => r.data),

  count: (queryString) =>
    axios.get(`${BASE}/contacts/count?${queryString}`, { headers: authHeaders() }).then(r => r.data),

  getOne: (id) =>
    axios.get(`${BASE}/contacts/${id}`, { headers: authHeaders() }).then(r => r.data),

  create: (data) =>
    axios.post(`${BASE}/contacts`, data, { headers: authHeaders() }).then(r => r.data),

  update: (id, data) =>
    axios.patch(`${BASE}/contacts/${id}`, data, { headers: authHeaders() }).then(r => r.data),

  delete: (id) =>
    axios.delete(`${BASE}/contacts/${id}`, { headers: authHeaders() }).then(r => r.data),
};
